// this is a general text-whitelabel file for general request messages and message parts

export const fetchingError = "Error fetching"
